import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    //   mode: "history",
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: [
		{
		    path: "/",
		    redirect: {
		        name: "index"
		    }
		},
        {
            path: "/index",
            name: "index",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/index/index.vue")
        },
		{
		    path: "/item",
		    name: "item",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/index.vue")
		},
		{
		    path: "/item/:code",
		    name: "itemDetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/detail.vue")
		},
		{
		    path: "/activity",
		    name: "activity",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/activity/index.vue")
		},
		{
		    path: "/activity/:code",
		    name: "activityDetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/activity/detail.vue")
		},
        {
            path: "/user",
            name: "user",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/index.vue")
        },
		{
		    path: "/account",
		    name: "account",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/account.vue")
		},
		{
		    path: "/addcount",
		    name: "addcount",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/addcount.vue")
		},
		{
		    path: "/addcountUsdt",
		    name: "addcountUsdt",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/addcountUsdt.vue")
		},
        {
            path:"/hongtou",
            name:"hongtou",
            component:() =>
                import("./views/user/hongtou.vue")
        },
		{
		    path: "/moneybag",
		    name: "moneybag",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/moneybag.vue")
		},
		{
		    path: "/moneyAuth",
		    name: "moneyAuth",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/moneyAuth.vue")
		},
		{
		    path: "/rechargeRecord",
		    name: "rechargeRecord",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/rechargeRecord.vue")
		},
        {
            path:"/unbindBankCard",
            name:"unbindBankCard",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/unbindBankCard.vue")
        },
        {
            path:"/losePage",
            name:"losePage",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/losePage.vue")
        },
        {
            path:"/payment",
            name:"payment",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/payment.vue")
        },
        {
            path:"/paymentBig",
            name:"paymentBig",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/paymentBig.vue")
        },
        {
            path:"/loseRecovery",
            name:"loseRecovery",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/loseRecovery.vue")
        },
        {
            path:"/receive",
            name:"receive",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/receive.vue")
        },
        {
            path:"/benefit",
            name:"benefit",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/benefit.vue")
        },
        {
            path:"/reward",
            name:"reward",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/reward.vue")
        },
        {
            path:"/records",
            name:"records",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/records.vue")
        },
        {
            path:"/recordBank",
            name:"recordBank",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/recordBank.vue")
        },
        {
            path:"/recordWithdrawBig",
            name:"recordWithdrawBig",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/recordWithdrawBig.vue")
        },
        {
            path:"/downloadApp",
            name:"downloadApp",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/downloadApp.vue")
        },
        {
            path:"/openChat",
            name:"openChat",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/openChat.vue")
        },
		{
		    path: "/withdrawRecord",
		    name: "withdrawRecord", 
		    component: () => 
		        import(/* webpackChunkName: "home" */ "./views/user/withdrawRecord.vue")
		},
		{
		    path: "/withdraw",
		    name: "withdraw", 
		    component: () => 
		        import(/* webpackChunkName: "home" */ "./views/user/withdraw.vue")
		},
		{
		    path: "/withdrawBig",
		    name: "withdrawBig", 
		    component: () => 
		        import(/* webpackChunkName: "home" */ "./views/user/withdrawBig.vue")
		},
        {
            path:"/address",
            name:"address",
            component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/address.vue")
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/login.vue")
        },
        {
            path: "/register",
            name: "register",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/register.vue")
        },
        {
            path: "/forgetpwd",
            name: "forgetpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/forgetpwd.vue")
        },
        {
            path: "/fiveStars",
            name: "fiveStars",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/fiveStars.vue")
        },
        {
            path: "/onlineBank",
            name: "onlineBank",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/onlineBank.vue")
        },
        {
            path: "/onlineBankDetails",
            name: "onlineBankDetails",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/onlineBankDetails.vue")
        },
        {
            path: "/invest",
            name: "invest",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest.vue")
        },
        {
            path: "/inviteNew",
            name: "inviteNew",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/inviteNew.vue")
        },
        {
            path: "/inviteWithdrawal",
            name: "inviteWithdrawal",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/inviteWithdrawal.vue")
        },
        {
            path: "/invest/alipay",
            name: "pay",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
        },
        {
            path: "/invest/wx",
            name: "wx",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
        },
		{
		    path: "/invest/usdt",
		    name: "usdt",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
		},
        {
            path: "/invest/bank",
            name: "bankpay",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest_bank.vue")
        },
        {
            path: "/cash",
            name: "cash",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/cash.vue")
        },
        {
            path: "/safe",
            name: "safe",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/safe.vue")
        },
        {
            path: "/setpwd",
            name: "setpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpwd.vue")
        },
        {
            path: "/setpaypwd",
            name: "setpaypwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpaypwd.vue")
        },
        {
            path: "/order",
            name: "order",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/order.vue")
        },
        {
            path: "/funds",
            name: "funds",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/funds.vue")
        },
		{
		    path: "/myTeam",
		    name: "myTeam",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/myTeam.vue")
		},
        {
            path: "/notice",
            name: "notice",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice.vue")
        },
        {
            path: "/notice/:id",
            name: "noticeid",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice_article.vue")
        },
        {
            path: "/about",
            name: "about",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/about.vue")
        },
        {
            path: "/about/:code",
            name: "article",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/article.vue")
        },
        
		{
		    path: "/search",
		    name: "search",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/search.vue")
		},
        {
            path: "/kefu",
            name: "kefu",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/kefu.vue")
        },
        {
            path: "/sign",
            name: "sign",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/sign.vue")
        },
		{
		    path: "/luckDraw",
		    name: "luckDraw",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/luckDraw.vue")
		},
		{
		    path: "/authEmail",
		    name: "authEmail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/authEmail.vue")
		},
		
		{
		    path: "/language",
		    name: "language",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/language.vue")
		},
    ]
});
